import {initiateTimeOutDownload} from 'features/postGenerator/utils/htmlToPng/handlePngDownload';

interface IProps {
  postRefs: React.MutableRefObject<HTMLDivElement[]>;
  fileName: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const onError = (error: unknown, message: string = 'Download post error') => {
  // eslint-disable-next-line
  console.log(error, message);
};

export const downloadPost = async ({fileName, postRefs, setLoading}: IProps) => {
  const listOfPosts = postRefs.current;
  initiateTimeOutDownload(0, listOfPosts, fileName, onError, setLoading);
};
